import React from 'react'

import { FilterOptionPostCountCell } from 'features/charts-v2/components/filter-option-post-count-cell'
import {
  PaneRow,
  PaneRowOnlyButton,
  PaneValueLabel,
  SentimentValueRowContainer,
  SentimentValueRowLeft,
  SmallCheckbox,
} from 'features/charts-v2/components/filter-popover-pane.styles'
import { FilterOptionValue } from 'features/filters/types'
import {
  ALIAS_FOR_NULL_VALUES,
  isNullValueAlias,
} from 'src/constants/filter-values'

interface SentimentValueRowProps {
  value: FilterOptionValue
  isChecked: boolean
  onToggle: () => void
  onOnly: () => void
}

// One categorical sentiment value row — a checkbox + label, and an
// on-row-hover "only" affordance + post count on the right. Same shape as
// every other value-list row in the popover.
export const SentimentValueRow: React.FC<SentimentValueRowProps> = ({
  value,
  isChecked,
  onToggle,
  onOnly,
}) => (
  <SentimentValueRowContainer $active={isChecked} onClick={onToggle}>
    <SentimentValueRowLeft>
      <SmallCheckbox checked={isChecked} onChange={() => {}} />
      <PaneValueLabel>
        {isNullValueAlias(value.value) ? ALIAS_FOR_NULL_VALUES : value.value}
      </PaneValueLabel>
    </SentimentValueRowLeft>
    <PaneRow>
      <PaneRowOnlyButton
        className="row-action-btn"
        onClick={(e) => {
          e.stopPropagation()
          onOnly()
        }}
      >
        only
      </PaneRowOnlyButton>
      <FilterOptionPostCountCell nPosts={value.n_posts} />
    </PaneRow>
  </SentimentValueRowContainer>
)
